





















































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import BookNavigation from "@/views/UnterrichtKnowledge/BookNavigation.vue";
import IframePageRenderer from "@/views/UnterrichtKnowledge/IframePageRenderer.vue";

const WikiDriveBuzzModule = namespace("wiki-drive-buzz");

@Component({
  components: {
    BookNavigation,
    IframePageRenderer,
  },
})
export default class BookViewer extends Vue {
  public isSectionMode = false;
  public currentSection: any = null;
  public currentPageTitle = "";
  private channel = new BroadcastChannel("book-mirror");

  @Prop({ required: true }) book!: any;
  @Prop({ required: true }) page!: string;

  @WikiDriveBuzzModule.Action("findHtmlPage")
  findHtmlPage!: any;

  @WikiDriveBuzzModule.Getter("getIsLoading")
  isLoading!: boolean;

  @WikiDriveBuzzModule.Getter("getIsPageLoading")
  getIsPageLoading!: boolean;

  public handleShowPage({ pageId, section }: { pageId: number; section: any }): void {
    this.findHtmlPage({ pageId, bookId: this.book?.id });
    this.setCurrentPageTitle(pageId);
    this.isSectionMode = false;
    this.currentSection = section;
  }

  public handleShowSection(section: any): void {
    this.currentSection = { ...section };
    this.currentPageTitle = "";
    this.isSectionMode = true;
  }

  public handleOpenInNewTab() {
    window.open(`${window.location.origin}/book-mirror`, "_blank");

    setTimeout(() => {
      this.channel.postMessage({
        title: this.currentPageTitle,
        content: this.page,
      });
    }, 2500);
  }

  @Watch("page")
  onPageChanged(newPage: string) {
    this.channel.postMessage({ title: this.currentPageTitle, content: newPage });
    this.channel.postMessage({ scrollY: 0 });
  }

  public syncIframeScroll() {
    const iframe = this.$el.querySelector("iframe") as HTMLIFrameElement;

    //@ts-ignore
    iframe?.contentWindow.addEventListener("scroll", () => {
      const win = iframe.contentWindow!;
      const ratio = win.scrollY / (win.document.body.scrollHeight - win.innerHeight);
      this.channel.postMessage({ scrollRatio: ratio });
    });
  }

  public generateTableOfContents(): void {
    const tocContainer = this.$el.querySelector(".table-of-content-container");
    const iframe = this.$el.querySelector("iframe") as HTMLIFrameElement;

    if (!tocContainer || !iframe?.contentDocument) return;

    const headings = iframe.contentDocument.querySelectorAll("h1[id], h2[id], h3[id], h4[id], h5[id]");
    if (!headings.length) return;

    tocContainer.innerHTML = "";

    const title = document.createElement("div");
    title.textContent = "Seitennavigation";
    title.className = "page-navigation-title";

    const ul = document.createElement("ul");
    ul.className = "toc-list";

    headings.forEach((heading) => {
      const id = heading.getAttribute("id");
      const text = heading.textContent?.trim();
      if (!id || !text) return;

      const li = document.createElement("li");
      const a = document.createElement("a");
      a.href = `#${id}`;
      a.textContent = text;
      a.addEventListener("click", (event) => {
        event.preventDefault();
        const target = iframe.contentDocument?.querySelector(`#${CSS.escape(id)}`);
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      });

      li.appendChild(a);
      ul.appendChild(li);
    });

    tocContainer.appendChild(title);
    tocContainer.appendChild(ul);
    this.syncIframeScroll();
  }

  private setCurrentPageTitle(pageId: number): void {
    for (const content of this.book.contents || []) {
      for (const page of content.pages || []) {
        if (page.id === pageId) {
          this.currentPageTitle = page.name;
          return;
        }
      }
    }
    this.currentPageTitle = "";
  }

  activated() {
    // Mirror currently opened book tab
    this.channel.postMessage({ title: this.currentPageTitle, content: this.page });
    this.channel.postMessage({ scrollY: 0 });
  }
}
